import { render, staticRenderFns } from "./BindDD.vue?vue&type=template&id=f9580364"
import script from "./BindDD.vue?vue&type=script&lang=js"
export * from "./BindDD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports